import { Box, Button, CircularProgress, FormControl, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmDialogList from '../../../../../components/ConfirmDialogList';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useDeleteLicitacaoMutation, useGetLicitacoesQuery } from './licitacaoApiSlice';
import { LicitacaoDataTable } from './LicitacaoDataTable';
import { ISlicitacao, Licitacao, LicitacaoList } from '../types/Licitacao';

export const LicitacaoListForm = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [licitacoes, setLicitacoes] = useState<LicitacaoList[]>([]);

  const [licitacaoToDelete, setLicitacaoToDelete] = useState<Licitacao>(ISlicitacao);
  const [openConfirmExcluir, setOpenConfirmExcluir] = useState(false);
  const [deleteLicitacao, { error: errorLicitacao, isLoading, isSuccess }] = useDeleteLicitacaoMutation();

  const [search, setSearch] = useState<string>('');
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const cursorPosition = useRef<number>(0);

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    cursorPosition.current = inputRef.current?.selectionStart || 0;
    setSearch(e.target.value);
  };

  useEffect(() => {
    // Limpar o timeout anterior
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Configurar o timeout para o debounce
    debounceTimeout.current = setTimeout(() => {
      setDebouncedSearch(search);
    }, 700); // Tempo de debounce (700ms)

    // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [search]); // Dependência do useEffect: quando o 'search' mudar

  const { data, isFetching, error } = useGetLicitacoesQuery({
    search: debouncedSearch
  });

  useEffect(() => {
    if (data) {
      setLicitacoes(data);
    }
    if (error) {
      enqueueSnackbar('Registro  não encontrados!', { variant: 'error' });
    } else if (isFetching) {
      enqueueSnackbar('Buscando registros...', { variant: 'info' });
    }

    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current?.setSelectionRange(cursorPosition.current, cursorPosition.current);
    }
  }, [data, error, isFetching, enqueueSnackbar]);

  const handleExcluirtClick = (rowData: any) => {
    setLicitacaoToDelete(rowData);
    setOpenConfirmExcluir(true);
  };
  const handleCloseDialog = () => {
    setOpenConfirmExcluir(false);
  };
  const handleConfirm = async () => {
    setOpenConfirmExcluir(false);
    await deleteLicitacao({
      id: licitacaoToDelete.id ? licitacaoToDelete.id : ''
    });
  };

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Registro deletado com sucesso!', { variant: 'success' });
      // fetchDados();
    }
    if (errorLicitacao) {
      enqueueSnackbar('Registro não deletado!', { variant: 'error' });
    }
  }, [isSuccess, errorLicitacao]);

  if (isFetching || loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <ConfirmDialogList
        open={openConfirmExcluir}
        handleClose={handleCloseDialog}
        title="Confirmar Ação"
        text={['Você tem certeza de que deseja excluir essa Licitação?', licitacaoToDelete.objeto ? licitacaoToDelete.objeto : '']}
        handleDelete={() => {
          handleConfirm(); // Chama a função handleConfirm
          setOpenConfirmExcluir(false); // Fecha o diálogo
        }}
      />

<Paper sx={{ width: '100%', height: '100vh', padding: '12px', display: 'flex', flexDirection: 'column' }}>
        <Grid container padding={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Box display="flex">
                  <Typography color="secondary" variant="h6" gutterBottom>
                    Licitações
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="flex-end" gap={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      navigate(configSiteUrls.SITE_LICITACAO_CREATE);
                    }}
                  >
                    Novo
                  </Button>

                  <Button variant="contained" color="secondary" onClick={() => navigate(-1)}>
                    Voltar
                  </Button>
                </Box>
              </Box>
            </FormControl>
          </Grid>

          <Grid item xs={12} mt={5}>
            <FormControl fullWidth>
              <TextField label="Digite para pesquisar" name="nome" onChange={handleChangeSearch} size="small" inputProps={{ maxLength: 100 }} value={search} inputRef={inputRef} />
            </FormControl>
          </Grid>
        </Grid>

        <LicitacaoDataTable licitacoes={licitacoes} handleExcluirtClick={handleExcluirtClick} baseEditUrl={configSiteUrls.SITE_LICITACAO_EDIT_LK} />
      </Paper>
    </>
  );
};
